import dayjs from 'dayjs'
import {
  emailMap,
  currentSymbolMap,
  phoneCodeMap,
  enMonthArr
} from '@/constants/index'

export function getEmailByLocale(locale: string): string {
  return emailMap[locale] || emailMap.HK
}

export function getCurrentByLocale(locale: string): string {
  console.log('getCurrentByLocale locale', locale)
  return currentSymbolMap[locale] || currentSymbolMap.HK
}

export function getPhoneCodeByLocale(locale: string): string {
  return phoneCodeMap[locale] || phoneCodeMap.HK
}

export function getJumpToPCWebsiteUrlByLang(lang: string) {
  let url = ''
  switch (lang) {
    case 'zh-TW':
      url = `https://hk.poizon.com/zh-hk/`
      break
    case 'zh-TW2':
      url = `https://tw.poizon.com/zh-tw/`
      break
    case 'zh-MO':
      url = `https://mo.poizon.com/zh-mo/`
      break
    default:
      url = `https://www.poizon.com/${lang}/`
  }
  return url
}

// 跳转到PC官网
export function jumpToPcWebsite(lang: string) {
  const url = getJumpToPCWebsiteUrlByLang(lang)
  window.location.href = url
}

export function getShowMonthAndYearByLang(value: string, lang: string) {
  try {
    const dayValue = dayjs(value)
    const month = dayValue.month()
    const year = dayValue.year()
    if (lang === 'en') {
      const monthStr = enMonthArr[month].slice(0, 3)
      return `${monthStr}.  ${year}`
    }
    const yearDesc = lang === 'ko' ? '년' : '年'
    const monthDesc = lang === 'ko' ? '월' : '月'
    // TODO 抽离
    return `${year}${yearDesc}${month + 1}${monthDesc}`
  } catch (error) {
    return ''
  }
}

const width = 375
export function pxToVw(px: number) {
  const vwNumber = (px / width) * 100
  return `${vwNumber}vw`
}

/**
 * aes对称加密
 * @param {需要加密的headr字段} str
 * @returns {string}
 */

export function encrypt(str) {
  let result = ''
  if (str) {
    try {
      const CryptoJS = require('jscrypto')
      // 秘钥
      const aseKey = '1CAA95FD37965D114F842804B2D6FA5E'
      // //将秘钥转换成Utf8字节数组
      // const key = CryptoJS.enc.Utf8.parse(aseKey)
      const bytes = CryptoJS.AES.encrypt(JSON.stringify(str), aseKey, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      })
      const originalText = bytes.toString()
      if (originalText) {
        result = originalText
      }
    } catch (error) {
      // TODO: 加密失败
      console.log(`error:`, error)
    }
  }
  return result
}

// 获取主域名(根域名)
export function getMainHost() {
  const key = `mh_${Math.random()}`
  const keyR = new RegExp(`(^|;)\\s*${key}=12345`)
  const expiredTime = new Date(0)
  const domain = document.domain
  const domainList = domain.split('.')

  const urlItems: string[] = []
  // 主域名一定会有两部分组成
  urlItems.unshift(domainList.pop() as string)
  // 慢慢从后往前测试
  while (domainList.length) {
    urlItems.unshift(domainList.pop() as string)
    const mainHost = urlItems.join('.')
    const cookie = `${key}=${12345};domain=.${mainHost}`
    document.cookie = cookie
    // 如果cookie存在，则说明域名合法
    if (keyR.test(document.cookie)) {
      document.cookie = `${cookie};expires=${expiredTime}`
      return mainHost
    }
  }
}

export function deleteEmptyParam(obj: object) {
  Object.keys(obj)
    // @ts-ignore
    .filter(
      (key) =>
        (typeof obj[key] === 'string' && obj[key].trim() === '') ||
        obj[key] === null ||
        obj[key] === undefined ||
        (Array.isArray(obj[key]) && !obj[key].length)
    )
    .forEach((key) => {
      // @ts-ignore
      delete obj[key]
    })
}
/**
 * 从nezha搭建的链接中提取URL中提取产品PageID
 * @param url
 * @returns
 */
export function extractProductId(url) {
  // 定义一个正则表达式来匹配URL中的产品ID
  const regex = /\/poizon\/detail\/[^\/]+\/[^\/]+\/([0-9a-fA-F]+)\b/
  const match = url.match(regex)

  // 如果匹配成功，则返回捕获的产品ID，否则返回null
  return match ? match[1] : null
}
